import {
    setNameOrId,
    ProductNames,
    ProductIdentifiers,
    RequestStatus,
    ConcernElementsInformationOwner, ProductType
} from "@/libs/product";
import {LegislationApi, ProductApi} from "@core/api";
import {receivedRequestProvider, clearCachedReceivedRequest} from "@core/domain/product";
import backendResponse from "@core/mixins/ui/backend-response";
import {InformationLevel} from "@core/domain/legislation";
import {getSubstanceList} from "@core/domain/substance";

export default {
    mixins: [backendResponse],
    data() {
        return {
            saveTimeoutId: null,
            otherInformation: {},
            inited: false,
            showLoading: true,
            request: {
                customer: {
                    title: ''
                },
                customerProduct: {
                    name: '',
                    identifier: '',
                },
                product: {
                    identifiers: [],
                    names: []
                },
                verificationDocuments: [],
                evidenceReportTypes: [],
                legislations: [],
                guaranteedWeightPercentageConfirmed: false,
                substanceState: null,
                lifeCycle: [],
                otherInformation: {},
            },
            concernElements: [],
            componentsConcernElements: [],
            saveRequestTimeoutId: null,
            isDeclarationApproved: false,
            convertTypeTimeoutId: null,
            otherReplyInformationLoading: false,
            legislations: [],
            showProductWeightMessage: false,
            isProductWeightRequired: false,
        };
    },

    methods: {
        manageSupplierChange(idList, suppliers) {
            receivedRequestProvider(this.id)
                .getProduct()
                .then(product => {
                    product
                        .changeSuppliers(suppliers)
                        .catch(this.handleBackendError);
                });
        },

        characteristicsChanged(characteristics) {
            receivedRequestProvider(this.id)
                .getProduct()
                .then(product => {
                    product.setProductCharacteristics(characteristics);
                    this.saveProduct();
                    this.recalculateShowProductWeightMessage();
                });
        },

        onProductTypeChange(type, success, error) {
            clearTimeout(this.convertTypeTimeoutId);
            this.convertTypeTimeoutId = setTimeout(() => {
                receivedRequestProvider(this.id)
                    .getProduct()
                    .then(product => {
                        product
                            .convertType(type)
                            .then(() => {
                                this.product.type = type;
                                this.calculateInformationOwner(true);
                                if (success) {
                                    success();
                                }
                            })
                            .catch(e => {
                                if (error) {
                                    error(e);
                                }
                            })
                        ;
                    });
            }, 1000);
        },

        declarationApproved() {
            this.isDeclarationApproved = true;
            this.changeStepValidity(7, true);
            if (this.isBulkReplyCandidatesStepVisible) {
                this.$nextTick(() => {
                    if (this.$refs.stepBulkReplyCandidates) {
                        this.$refs.stepBulkReplyCandidates.updateVisible(true);
                    } else if (this.$refs.stepSendReply) {
                        this.$refs.stepSendReply.updateVisible(true);
                    }
                });
            } else if (this.$refs.stepSendReply) {
                this.$nextTick(() => {
                    this.$refs.stepSendReply.updateVisible(true);
                });
            }

            this.$store.dispatch('declarationApproved');
        },

        saveProduct(timeout = 2500, completionCallback = null) {
            if (!this.inited) {
                return;
            }
            clearTimeout(this.saveTimeoutId);
            this.saveTimeoutId = setTimeout(() => {
                this.showLoading = true;
                this.save(
                    false,
                    false,
                    false,
                    false
                ).finally(() => {
                    if (completionCallback) {
                        completionCallback();
                    }
                    this.showLoading = false
                })
                    // .finally(() => this.showLoading = false);
            }, timeout);
        },

        onHasConcernSubstanceChange(hasConcernElements) {
            if (false === hasConcernElements) {
                if (this.$refs.step4) {
                    this.$refs.step4.updateVisible(true);
                }
            }

            this.hasConcernSubstances(hasConcernElements);
            // this.saveProduct();
            this.saveProductCard();
        },

        saveProductCard() {
            return receivedRequestProvider(this.id)
                .getProduct()
                .then(product => {
                    return product.saveCard();
                });
        },

        onComponentIncluded(component, order) {
            this.request.product.isComplex = true;
        },

        updateComponent(component) {
            return receivedRequestProvider(this.id)
                .getProduct()
                .then(product => {
                    return product.updateComponent(component);
                })
            ;
        },

        onHierarchyChange() {
            receivedRequestProvider(this.id)
                .getProduct()
                .then(product => {
                    //product.hierarchyChanged();
                    this.fetchComponentsConcernElements();
                    this.$refs.ConcernElementsComponent.fetchHierarchy();
                    if (this.$refs.ProductInformation) {
                        this.$refs.ProductInformation.fetchHierarchy();
                    }
                })
            ;
        },

        onConcernElementsModalSelectorClose() {
            this.showLoading = true;
            this
                .save(
                    false,
                    false,
                    false,
                    false
                )
                .then(() => {
                    receivedRequestProvider(this.id)
                        .refreshSubstanceState();
                    this
                        .fetchConcernElements()
                        .then(() => this.showLoading = false);
                })
            ;
        },
        excludeModal(substance) {
            this.excludeConcernSubstance(substance);
            this.recalculateShowProductWeightMessage();
        },
        makeUndefined(substance, save, completionCallback) {
            this.makeSubstanceUndefined(substance);
            if (save) {
                this.saveProduct(0, completionCallback);
            }
            this.recalculateShowProductWeightMessage();
        },

        includeSubstance(substance, substanceListIds = []) {
            this.includeConcernSubstance(substance, substanceListIds);
            this.recalculateShowProductWeightMessage();
        },
        excludeSubstance(substance) {
            this.excludeConcernSubstance(substance);
            this.saveProduct();
            this.recalculateShowProductWeightMessage();
        },

        productPropertiesChanged(substance, properties, completionCallback) {
            this.onSubstancePropertiesChange(substance, properties);
            this.saveProduct(0, completionCallback);
        },

        manageSubstanceDetailsChange(substance, details, completionCallback) {
            this.onSubstanceDetailsChange(substance, details);
            this.saveProduct(0, completionCallback);
        },

        informationOwnerChange(informationOwner) {
            receivedRequestProvider(this.request.id).setInformationOwner(informationOwner)
            this.saveReceivedRequest();
        },

        isComplexChange(isComplex) {
            receivedRequestProvider(this.request.id).setIsComplex(isComplex);

            //  in case we set product is not complex and checked we have information and there is no any
            //  concern elements
            //  but when we change our mind that product is complex and has components we need to unset hasConcernSubstances
            //  ?
            // if (isComplex && this.request.informationOwner === ConcernElementsInformationOwner.WE && this.request.product.hasConcernSubstances === false) {
            //     if (this.componentsConcernElements.length > 0) {
            //         this.onHasConcernSubstanceChange()
            //     }
            // }
            this.calculateInformationOwner();

            this.saveReceivedRequest();
        },

        calculateInformationOwner(save = false) {
            //  HAM-460
            // if (this.request.isComplexProduct) {
            //     return;
            // }
            const informationOwner = this.request.informationOwner;
            if (null === informationOwner || ConcernElementsInformationOwner.WE_PARTIALLY === informationOwner) {
                if (ProductType.OWN === this.request.product.type) {
                    receivedRequestProvider(this.request.id).setInformationOwner(ConcernElementsInformationOwner.WE);

                    if (save) {
                        this.saveReceivedRequest();
                    }
                }
            } else if (ConcernElementsInformationOwner.WE === informationOwner) {
                const types = [
                    ProductType.PURCHASED_UNDEFINED_SUPPLIER,
                    ProductType.PURCHASED
                ];

                if (types.includes(this.request.product.type)) {
                    let state = null;

                    //  from ProductCard mixin
                    if (this.includedSubstances.length > 0 && this.request.product.hasConcernSubstances) {
                        state = ConcernElementsInformationOwner.WE_PARTIALLY;
                    }

                    receivedRequestProvider(this.request.id).setInformationOwner(state);

                    if (save) {
                        this.saveReceivedRequest();
                    }
                }
            }
            //  END
        },

        onOtherInformationChange(otherInformation) {
            this.otherInformation = otherInformation;
            receivedRequestProvider(this.request.id).setOtherInformation(this.otherInformation);
            this.saveReceivedRequest(
                () => this.otherReplyInformationLoading = true,
                () => this.otherReplyInformationLoading = false,
            );
        },

        saveReceivedRequest(beforeSave, afterSave) {
            clearTimeout(this.saveRequestTimeoutId);
            this.saveRequestTimeoutId = setTimeout(() => {
                if (beforeSave) {
                    beforeSave();
                }
                receivedRequestProvider(this.request.id)
                    .save()
                    .then(afterSave);
            }, 2000);
        },

        manageScipChange(scip) {
            setNameOrId(this.product.names, ProductNames.SCIP_NAME, scip.name);
            setNameOrId(this.product.identifiers, ProductIdentifiers.SCIP_NUMBER, scip.id);

            this.saveProduct();
        },

        onDocumentChange(declarationOrEvidenceDocument) {
            if (declarationOrEvidenceDocument.id || (!declarationOrEvidenceDocument.id && declarationOrEvidenceDocument.document)) {
                this.saveProduct();
            }
        },

        verificationSafeUseChange(isApplicable) {
            this.safeUseApplicableChange(isApplicable);
            this.saveProduct();
        },
        safeUseDocumentChange(instructions) {
            this.safeUseChange(instructions);
            if (instructions.document || instructions.id || instructions.description) {
                this.saveProduct();
            }
        },
        dissemblingDocumentChange(instructions) {
            this.disassemblingChange(instructions);
            if (instructions.document || instructions.id || instructions.description) {
                this.saveProduct();
            }
        },
        makeDeclaration() {
            let documents = this.declarationsOfConformity
                .concat(this.evidenceReports)
                .concat(this.compliantStatement);
            documents.push(this.safeUseInstructions)
            documents.push(this.disassemblingInstructions)

            return {
                documents: documents,
                internalComment: this.otherInformation ? this.otherInformation.internalComment : null,
                declarationValidity: this.otherInformation ? this.otherInformation.declarationValidity : null,
                customerInformation: this.otherInformation ? this.otherInformation.customerInformation : null
            };
        },
        forward() {
            if (this.$store.getters.showSendEmailSettingsStep) {
                this.$router.push({
                    name: 'request-email-options',
                    query: {
                        n: 'forward-request',
                        nid: this.id,
                        b: 'received-request',
                        bid: this.id
                    }
                });
            } else {
                this.$router.push({
                    name: 'forward-request',
                    params: {id: this.request.id, req: this.request},
                    props: {request: this.request},
                });
            }
        },

        sendReply() {
            this.showLoading = true;
            ProductApi
                .replyToRequest(this.id, this.makeDeclaration())
                .then(() => {
                    this.request.status = RequestStatus.REPLIED;
                    this.$swal({
                        title: this.$t('Page(ReceivedRequest):Component(SendReplyAck):title'),
                        text: this.$t('Page(ReceivedRequest):Component(SendReplyAck):text'),
                        icon: 'success',
                        timer: 1300,
                        allowOutsideClick: true,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    });
                    clearCachedReceivedRequest(this.id);
                    return this
                        .fetchProductRequest()
                        .then(request => {
                            this.request = request.request;
                        });
                })
                .catch(this.handleBackendError)
                .finally(() => {
                    this.showLoading = false;
                })
            ;
        },

        fetchProductRequest() {
            return receivedRequestProvider(this.id)
                .getRequest()
                .then(request => {
                    this.request = request.request;
                    this.product = request.request.product;
                    this.productId = request.request.product.id;
                    this.safeUseApplicable = request.request.product.isSafeUseApplicable;

                    if (request.request.otherInformation) {
                        this.otherInformation = request.request.otherInformation;
                    }

                    return request;
                });
        },

        markStepAsDone(step) {
            const request = receivedRequestProvider(this.id);

            if (!request.isStepDone(step)) {
                request.markStepAsDone(step);
                request.save();
            }
        },

        markStepAsUnDone(step) {
            const request = receivedRequestProvider(this.id);
            request.markStepAsUnDone(step);
            return request.save();
        },

        fetchConcernElements() {
            return receivedRequestProvider(this.id)
                .getProduct()
                .then(product => {
                    return product.getConcernElements();
                })
                .then(elements => {
                    this.concernElements = elements;
                });
        },

        makeCustomCodesAndManufacturingOriginComponents() {

        },

        fetchComponentsConcernElements() {
            return receivedRequestProvider(this.id)
                .getProduct()
                .then(product => {
                    return product.getComponentsSubstancesForLegislations(this.request.legislations);
                })
                .then(elements => {
                    // this.concernElements = elements;
                    this.componentsConcernElements = elements;
                    this.makeCustomCodesAndManufacturingOriginComponents();

                    return this.componentsConcernElements;
                });
        },

        fetch() {
            return new Promise((resolve, reject) => {
                this.fetchProductRequest().then((request) => {
                    resolve();

                    // this.fetchConcernElements();
                    this.fetchComponentsConcernElements();
                    this.fetchSubstances(); // from ProductCardMixins
                    this.fetchDocuments();

                });
            });
        },

        recalculateShowProductWeightMessage: async function () {
            //  do not show if product weight is hidden
            if (!this.showProductWeight) {
                this.isProductWeightRequired = false;
                this.showProductWeightMessage = false;
                return;
            }

            //  check if weight is required in any requested legislation
            const requestedIds = this.request.legislations.map(l => l.id);
            const weightRelevantLegislations = this.legislations
                .filter(l => requestedIds.includes(l.id) && l.requirements.requiresProductWeight);

            if (weightRelevantLegislations.length === 0) {
                this.isProductWeightRequired = false;
                this.showProductWeightMessage = false;
                return;
            }

            // Helper to collect unique substances depending on product complexity
            const fetchUniqueSubstances = async (product) => {
                if (!product.isComplex()) {
                    const substances = await product.getSubstances();
                    return substances.included.map(is => is.substance);
                }
                const componentSubstances = await product.getComponentsSubstances(true);
                const byId = {};
                componentSubstances.forEach(cs => {
                    cs.substances.forEach(s => {
                        byId[s.substance.id] = s.substance;
                    });
                });
                return Object.values(byId);
            };

            // Helper to check if any legislation list includes any of the product's substances
            const hasRelevantIncludedSubstances = async (substances, legislations) => {
                for (const l of legislations) {
                    const substanceList = await getSubstanceList(l.substanceList.listKey);
                    const included = await substanceList.extractIncluded(substances);
                    if (included.length > 0) {
                        return true;
                    }
                }
                return false;
            };

            try {
                const product = await receivedRequestProvider(this.id).getProduct();
                const substances = await fetchUniqueSubstances(product);
                const relevant = await hasRelevantIncludedSubstances(substances, weightRelevantLegislations);

                this.isProductWeightRequired = relevant;
                this.showProductWeightMessage = relevant ? !this.request.product.characteristics.weight : false;
            } catch (e) {
                // On failure, be conservative and do not show the message
                this.isProductWeightRequired = false;
                this.showProductWeightMessage = false;
            }
        },
        fetched() {

        }
    },

    computed: {
        isApproveDeclarationStepDisabled() {
            return this.$store.getters.isDeclarationApproved;
        },
        isApproveDeclarationStepVisible() {
            return this.$store.state.user.profile.attributes.subscription.isActive === false;
        },
        isReplyStepActive() {
            if (this.isApproveDeclarationStepVisible && this.isApproveDeclarationStepDisabled) {
                return true;
            }
            return this.$store.state.user.profile.attributes.subscription.isActive === true;
        },
        showProductWeight() {
            const requestedLegislations = this.request.legislations.map(l => l.id);
            const legislationRequirements = this.legislations
                .filter(l => requestedLegislations.includes(l.id))
                .map(l => l.requirements.requiresProductWeight);

            return legislationRequirements.includes(true) || this.request.informationLevel === InformationLevel.FULL_MATERIAL_DECLARATION;
        },
    },

    created() {
        this.reInitData();
        this.fetch().then(() => {
            this.fetched();
            LegislationApi.all().then(r => {
                this.legislations = r.data;
                this.recalculateShowProductWeightMessage();
            });
            setTimeout(() => {
                this.showLoading = false;
                this.inited = true;
            }, 200);
        });
    },
};
